/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EmailCustomization} from '../models/EmailCustomization';
import type {Error} from '../models/Error';

export interface GetEmailTemplate$Request {
    accountId: number;
}

export interface GetEmailTemplate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getEmailTemplateRequest = createAction<PayloadData<void, GetEmailTemplate$Request>>('MICRO_SITES_EMAIL_TEMPLATE_CUSTOMIZATION__GET_EMAIL_TEMPLATE__REQUEST');
export const getEmailTemplateSuccess = createAction<PayloadData<EmailCustomization, GetEmailTemplate$Request>>('MICRO_SITES_EMAIL_TEMPLATE_CUSTOMIZATION__GET_EMAIL_TEMPLATE__SUCCESS');
export const getEmailTemplateFailure = createAction<PayloadData<Error, GetEmailTemplate$Request, true>>('MICRO_SITES_EMAIL_TEMPLATE_CUSTOMIZATION__GET_EMAIL_TEMPLATE__FAILURE');

export const getEmailTemplateActions = [
    getEmailTemplateRequest,
    getEmailTemplateSuccess,
    getEmailTemplateFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getEmailTemplate = (meta: GetEmailTemplate$Request, config?: GetEmailTemplate$Config) => {
    return {
        CALL_API: {
            types: getEmailTemplateActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/microsites/email-template`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateEmailTemplate$Request {
    accountId: number;
    emailCustomization: EmailCustomization;
}

export interface UpdateEmailTemplate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateEmailTemplateRequest = createAction<PayloadData<void, UpdateEmailTemplate$Request>>('MICRO_SITES_EMAIL_TEMPLATE_CUSTOMIZATION__UPDATE_EMAIL_TEMPLATE__REQUEST');
export const updateEmailTemplateSuccess = createAction<PayloadData<void, UpdateEmailTemplate$Request>>('MICRO_SITES_EMAIL_TEMPLATE_CUSTOMIZATION__UPDATE_EMAIL_TEMPLATE__SUCCESS');
export const updateEmailTemplateFailure = createAction<PayloadData<Error, UpdateEmailTemplate$Request, true>>('MICRO_SITES_EMAIL_TEMPLATE_CUSTOMIZATION__UPDATE_EMAIL_TEMPLATE__FAILURE');

export const updateEmailTemplateActions = [
    updateEmailTemplateRequest,
    updateEmailTemplateSuccess,
    updateEmailTemplateFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {EmailCustomization} meta.emailCustomization
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateEmailTemplate = (meta: UpdateEmailTemplate$Request, config?: UpdateEmailTemplate$Config) => {
    return {
        CALL_API: {
            types: updateEmailTemplateActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/microsites/email-template`,
            TRANSPORT_REQUEST_BODY: meta.emailCustomization,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

